<template>
  <v-card>
    <v-toolbar dark color="blue-grey white--text">
      <!-- <v-icon>contacts</v-icon> -->
      <v-toolbar-title class="white--text">
        <span class="title">ประเภทโครงการ</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-title>
      <v-text-field
        append-icon="search"
        label="ค้นหา"
        single-line
        hide-details
        v-model="pagination.q"
        clearable
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-tooltip left>
        <v-btn color="blue-grey" slot="activator" dark fab @click="addItem()">
          <v-icon>playlist_add</v-icon>
        </v-btn>
        <span>เพิ่มรายการ</span>
      </v-tooltip>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="items"
        :total-items="pagination.totalItems"
        :pagination.sync="pagination"
        hide-actions
      >
        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ ((pagination.page - 1) * pagination.rowsPerPage) + props.index + 1 }}</td>
          <td>{{ props.item.name }}</td>
          <td class="justify-center layout px-0">
            <v-tooltip left>
              <v-btn icon class="mx-0" slot="activator" @click="editItem(props.item)">
                <v-icon color="blue-grey">pageview</v-icon>
              </v-btn>
              <span>ดูข้อมูล</span>
            </v-tooltip>
            <v-btn icon class="mx-0" @click="deleteItem(props.item)">
              <v-icon color="pink">delete</v-icon>
            </v-btn>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ pagination.q }}" found no results.
        </v-alert>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination :length="Math.ceil(pagination.totalItems / pagination.rowsPerPage)" v-model="pagination.page" :total-visible="7"></v-pagination>
      </div>
    </v-card-text>
    
    <v-dialog v-model="dialog" max-width="70%">
      <v-card>
        <v-card-title>
          <span class="headline">{{ title.text }}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-form v-model="valid" ref="form" lazy-validation>
                  <v-textarea v-model="editedItem.name" label="ชื่อประเภทโครงการ" :rules="[rules.required]"></v-textarea>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="grey white--text" :loading="loading" :disabled="loading" @click.native="close">ยกเลิก</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" :loading="loading" :disabled="loading" @click.native="onSave">บันทึก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="preloading" persistent width="300">
      <v-card color="blue darken-3" dark>
        <v-card-text>
          กำลังโหลด...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import swal from 'sweetalert2'

export default {
  data () {
    return {
      dialog: false,
      formDialog: '',
      preloading: true,
      loading: false,
      search: '',
      valid: false,
      rules: {
        required: (value) => !!value || 'ไม่สามารถเป็นค่าว่าง'
      },
      title: {
        icon: null,
        text: null
      },
      headers: [
        { text: '#', sortable: false, align: 'center', width: '10'},
        { text: 'ชื่อประเภทโครงการ', value: 'name' },
        { sortable: false}
      ],
      pagination: {
        q: '',
        descending: true,
        page: 1,
        rowsPerPage: 10, // -1 for All
        sortBy: 'name',
        totalItems: 0
      },
      items: [],
      editedIndex: -1,
      editedItem: {},
      defaultItem: {}
    }
  },
  computed: {

    },
  mounted () {
    this.reload ()
  },
  methods: {
    addItem () {
      this.title.icon = 'add'
      this.title.text = 'เพิ่มรายการประเภทโครงการ'
      this.formDialog = 'form-dialog'
      this.editedItem.isGen = true
      this.editedItem.inside = true
      setTimeout(()=>{this.dialog = true}, 300)
    },
    editItem (item) {
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.title.icon = 'description'
      this.title.text = 'เรียกดูรายการประเภทโครงการ'
      this.formDialog = 'form-dialog'
      setTimeout(()=>{this.dialog = true}, 300)
    },
    deleteItem (item) {
      const index = this.items.indexOf(item)
      // confirm('Are you sure you want to delete this item?') && this.items.splice(index, 1)
      swal({
        title: 'คุณแน่ใจ?',
        text: "คุณจะไม่สามารถเรียกคืนข้อมูลได้อีก!",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่, ฉันต้องการลบข้อมูลนี้!'
      }).then((result) => {
        console.log('swal', result.value)
        if (result.value) {
          this.$store.dispatch('activityType/delete', item)
            .then((response) => {
                console.log('reload:', response )
                this.reload()
              }).catch((error) => {
                swal('เกิดข้อผิดพลาด!', error.message, 'error')
              })
          swal(
            'ลบรายการ!',
            'คุณได้ทำการลบรายการเรียบร้อยแล้ว',
            'success'
          )
        }
      })
    },
    close () {
      this.formDialog = null
      this.dialog = false
      this.reload ()
      this.editedItem = {}
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    onSave () {
      if (this.$refs.form.validate()) {
        this.loading = true
        let dispatch = this.editedItem.id && this.editedItem.id > 0 ? 'activityType/update' : 'activityType/create'
        this.$store.dispatch(dispatch, this.editedItem)
          .then((response) => {
            console.log('onSave:', response )
            this.loading = false
            swal({
              title: 'Success!',
              type: 'success'
            }).then(response => {
              this.close()
            })
          }).catch((error) => {
            this.loading = false
            swal('Error!', error.message, 'error')
          })
      }
    },
    reload () {
      this.loading = true
      this.$store.dispatch("activityType/loadItemsAsPage", this.pagination)
        .then((response) => {
          // console.log('page in response ->', this.pagination.page)
          this.pagination.totalItems = response.data.totalItems
          this.items = response.data.items
          this.loading = false
          this.preloading = false
        }).catch((error)=>{
          // console.log('reload', error)
          this.loading = false
          this.preloading = false
          swal('Error!', error.message, 'error')
        })
    }
  },
  watch: {
    'pagination.rowsPerPage' () {
      this.reload(this)
    },
    'pagination.q' () {
      this.pagination.page = 1
      this.reload(this)
    },
    'pagination.searches.companyCode' () {
      this.pagination.page = 1
      this.reload(this)
    },
    'pagination.searches.companyName' () {
      this.pagination.page = 1
      this.reload(this)
    },
    'pagination.searches.category' () {
      this.pagination.page = 1
      this.reload(this)
    },
    'pagination.searches.status' () {
      this.pagination.page = 1
      this.reload(this)
    },
    'pagination.page' () {
      this.reload(this)
    },
    'pagination.descending' () {
      this.reload(this)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/settings/activityType/index.vue